// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-sticky-top{top:3.5em;background:#fff;border-top:.5em solid #fff}", ""]);
// Exports
module.exports = exports;
